/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { register as registerSwiperElements } from 'swiper/element/bundle';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

registerSwiperElements();

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
